import axios from '@/axios.js'

export default {
  // CSV export for ERP import (one row per line item, full header). Same
  // filters as fetchApDocuments; resolves to the raw blob response.
  exportApDocumentsCsv(context, params) {
    return axios.get('/ap-documents/export', { params, responseType: 'blob' })
  },
  fetchApDocuments({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/ap-documents', {
          params: payload,
        })
        .then((response) => {
          commit('SET_AP_DOCUMENTS', response.data.data)
          commit('SET_PAGINATION', {
            currentPage: response.data.page,
            totalPage: response.data.totalPages,
            pageTotal: response.data.limit,
            totalItem: response.data.total,
          })
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  fetchApDocument({ commit }, uuid) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/ap-documents/${uuid}`)
        .then((response) => {
          commit('SET_AP_DOCUMENT', response.data)
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  fetchApDocumentsBySupplier({ commit }, { tin, page = 1, limit = 20 }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/ap-documents/by-supplier/${tin}`, {
          params: { page, limit },
        })
        .then((response) => {
          commit('SET_AP_DOCUMENTS', response.data.data)
          commit('SET_PAGINATION', {
            currentPage: response.data.page,
            totalPage: response.data.totalPages,
            pageTotal: response.data.limit,
            totalItem: response.data.total,
          })
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  fetchApDocumentsStats({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/ap-documents/stats', {
          params: payload,
        })
        .then((response) => {
          commit('SET_STATS', response.data)
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  fetchApDocumentsCountByStatus({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get('/ap-documents/count-by-status')
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  checkHasDocuments() {
    return new Promise((resolve, reject) => {
      axios
        .get('/ap-documents/check/has-documents')
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  triggerSync({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('/ap-documents/sync', payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  fetchSyncStatus({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get('/ap-documents/sync-status')
        .then((response) => {
          commit('SET_SYNC_STATUS', response.data)
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  cancelSync(context, syncId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/ap-documents/sync/${syncId}`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}

